export default __webpack_public_path__ + "static/img/29.b992274.png";